import type { IHttpClient } from '@wix/yoshi-flow-editor';

const REPORT_NEW_VISITOR_URL =
  '_api/wix-ai-assistant-visitor-presence/report-new-visitor';

export interface VisitorPresenceService {
  reportNewVisitor(params: { pageId: string; pageName: string }): Promise<void>;
}

export const createVisitorPresenceService = (
  httpClient: IHttpClient,
): VisitorPresenceService => ({
  async reportNewVisitor({ pageId, pageName }) {
    await httpClient.post(REPORT_NEW_VISITOR_URL, { pageId, pageName });
  },
});
